export interface ClientPermission {
  Permission: number;
  Checked: boolean;
  Default: boolean;
  Description: string;
  Group: string;
  PermissionText: string;
}

export enum PasswordDefinitionMode {
  None = 0,                
  SendDefinitionEmail = 1, 
  TemporaryPassword = 2
}

export interface UserProfile {
  PersonId: string;
  TenantId: string;
  Email: string;
  FirstName: string;
  IsOwner: boolean;
  AppSource: number;
  PhoneNumber: string | null;
  CountryCode: number;
  IsBookingVisitant: boolean;
  RoleId: string;
  Permissions: unknown | null;
  ClientPermissions: ClientPermission[];
  AbstractedTenantName: string;
  IsActive: boolean;
  AllowAccessFromAnyIp: boolean;
  PasswordDefinitionMode: PasswordDefinitionMode;
  TemporaryPassword?: string | null;
}
